import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DefaultLayout from "../../components/DefaultLayout";
import downArrow from "../../assets/down-arrow.svg";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from 'react-toastify';

import Chart from "react-apexcharts";
import {
  SubscriptionIcon,
  UsersIcon,
} from "../../assets/custom-icons";
import ReusableMenu from "../../components/menu/ReusableMenu";

const Dashboard = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [monthName, setMonthName] = useState("January");
  const [walletStats, setWalletStats] = useState({
    total_wallets: 0,
    active_subscriptions: 0
  });
  const [loading, setLoading] = useState(true);


  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    const fetchWalletStats = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get('/wallet/stats');
        if (response?.data?.success) {
          setWalletStats(response.data.data);
        } else {
          throw new Error(response?.data?.message || 'Failed to fetch wallet stats');
        }
      } catch (err) {
        toast.error(err.message || 'Failed to fetch wallet stats');
        console.error('Error fetching wallet stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchWalletStats();
  }, []);
  const options = {
    xaxis: {
      categories: ["10k", "20k", "30k", "40k", "50k", "60k", "70k"],
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 400,
          colors: "white",
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      colors: ["#D42121", "#6552FE"],
      width: 2,
    },
    colors: ["#C68300", "#6552FE"],
    chart: {
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    legend: {
      labels: {
        colors: "white",
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
          fontWeight: 400,
          colors: "white",
        },
      },
    },
    grid: {
      yaxis: {
        lines: {
          show: false, // Disable horizontal lines
        },
      },
      xaxis: {
        lines: {
          show: false, // Disable vertical lines
        },
      },
      strokeDashArray: 0, // Thin dashed line appearance
      borderColor: "rgba(255, 255, 255, 0.2)", // Light white-gray tint
    },
  };

  const series = [
    {
      name: "Sales",
      data: [31, 40, 28, 51, 42, 80, 100],
    },
    {
      name: "Profit",
      data: [20, 32, 45, 32, 34, 52, 41],
    },
  ];
  return (
    <>
      <DefaultLayout
        handleSearchChange={handleSearchChange}
        searchTerm={searchTerm}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
          <div className="w-full h-[161px] relative">
            <div className="w-full h-[161px] left-0 top-0 absolute bg-stone-900 rounded-[14px]" />
            <div className="h-6 left-[16px] right-[16px] top-[121px] absolute">
              {/* <RedArrowDownIcon className="w-6 h-6 left-0 top-[24px] absolute" /> */}
              {/* <div className="left-[32px] top-[3px] absolute">
                <span className="text-red-600 text-base font-semibold  ">
                  4.3%
                </span>
                <span className="text-zinc-100 text-base font-semibold  ">
                  {" "}
                </span>
                <span className="text-zinc-100 text-base font-medium  ">
                  from yesterday
                </span>
              </div> */}
            </div>
            <div className="w-16 h-16 p-4 right-[16px] top-[16px] absolute bg-indigo-500 bg-opacity-20 rounded-2xl border border-indigo-500 justify-center items-center gap-3 inline-flex">
              <UsersIcon className="w-8 h-8  relative" />
            </div>
            <div className="left-[16px] top-[16px] absolute opacity-70 text-zinc-300 text-base font-semibold  ">
              Total Wallets
            </div>
            <div className="left-[16px] top-[54px] absolute text-zinc-100 text-[28px] font-bold tracking-wide">
              {loading ? '...' : walletStats.total_wallets}
            </div>
          </div>
          <div className="w-full h-[161px] relative">
            <div className="w-full h-[161px] left-0 top-0 absolute bg-stone-900 rounded-[14px]" />
            <div className="h-6 left-[16px] right-[16px] top-[121px] absolute">
              {/* <RedArrowDownIcon className="w-6 h-6 left-0 top-[24px] absolute" /> */}
              {/* <div className="left-[32px] top-[3px] absolute">
                <span className="text-red-600 text-base font-semibold  ">
                  4.3%
                </span>
                <span className="text-zinc-100 text-base font-semibold  ">
                  {" "}
                </span>
                <span className="text-zinc-100 text-base font-medium  ">
                  from yesterday
                </span>
              </div> */}
            </div>
            <div className="w-16 h-16 p-4 right-[16px] top-[16px] absolute bg-indigo-500 bg-opacity-20 rounded-2xl border border-indigo-500 justify-center items-center gap-3 inline-flex">
              <SubscriptionIcon className="w-8 h-8  relative" />
            </div>
            <div className="left-[16px] top-[16px] absolute opacity-70 text-zinc-300 text-base font-semibold  ">
              Total Subscriptions
            </div>
            <div className="left-[16px] top-[54px] absolute text-zinc-100 text-[28px] font-bold   tracking-wide">
            {loading ? '...' : walletStats.active_subscriptions}
            </div>
          </div>
          <div className="w-full h-[161px] relative bg-stone-900 rounded-[14px] flex flex-col items-center justify-center gap-6 p-6">
            <Link
              to="/monthly-payment"
              className="group relative w-full h-[56px] rounded-[12px] bg-[conic-gradient(from_0deg_at_60.93%_-10%,_#6552FE_220.3deg,_#01FFF4_360deg)] hover:bg-[conic-gradient(from_0deg_at_60.93%_-10%,_#5a48e5_220.3deg,_#00e6db_360deg)] text-white font-semibold flex items-center justify-center transition-all duration-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <span className="relative z-10">Monthly Payment</span>
            </Link>
            <Link
              to="/current-month-transfer"
              className="group relative w-full h-[56px] rounded-[12px] bg-[conic-gradient(from_0deg_at_60.93%_-10%,_#6552FE_220.3deg,_#01FFF4_360deg)] hover:bg-[conic-gradient(from_0deg_at_60.93%_-10%,_#5a48e5_220.3deg,_#00e6db_360deg)] text-white font-semibold flex items-center justify-center transition-all duration-300 overflow-hidden"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-pulse opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <span className="relative z-10">Current Month Payments</span>
            </Link>
          </div>
        </div>


        <div className=" w-full flex-col justify-center items-center ">
            <h3 className="font-semibold text-4xl text-white my-7">Sales</h3>
            <div className=" w-full mt-4 rounded-xl bg-stone-900 ">
            <div className="flex justify-between p-5">
              <p className=" font-semibold text-2xl text-white">Revenue</p>
              <ReusableMenu
                buttonIcon={downArrow}
                isFetching={false}
                menuItems={[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ]}
                buttonText={monthName}
                handleChangeFun={setMonthName}
              />
            </div>
            <Chart options={options} series={series} type="area" height="380" />
          </div>
        </div>
      </DefaultLayout>
    </>
  );
};

export default Dashboard;
